import React from 'react';
import { splitSubtitleSegments } from '@packages/global';
import { BaseTrackItemProps } from './BaseTrackItem';

export default function TextTrackItem({ clip, pixelsPerSecond, isSelected, onSelect }: BaseTrackItemProps) {
  const clipWidth = clip.duration * pixelsPerSecond;

  const getBackgroundColor = () => {
    if (!clip.hasText && !clip.isGenerating) return 'bg-gray-400/30';
    return 'bg-orange-500/50';
  };

  const getSelectionStyle = () => {
    if (isSelected) return 'ring-2 ring-blue-400 bg-blue-200/30 shadow-lg';
    return '';
  };

  // 计算字幕分段（clip.name 对应字幕文本 clip.script）
  const segments = splitSubtitleSegments(clip.name || '', clip.duration);

  return (
    <div
      className={`absolute top-1 bottom-1 rounded cursor-pointer hover:opacity-80 transition-all overflow-hidden ${getBackgroundColor()} ${getSelectionStyle()}`}
      style={{
        left: `${clip.startTime * pixelsPerSecond}px`,
        width: `${clipWidth}px`
      }}
      onClick={onSelect}
    >
      {!clip.hasText && !clip.isGenerating ? (
        // 无字幕状态
        <div className="p-1 h-full flex items-center relative z-10">
          <span className="text-xs text-gray-600 truncate">无字幕</span>
        </div>
      ) : !clip.name && clip.isGenerating ? (
        // 生成中状态
        <div className="p-1 h-full flex items-center relative z-10">
          <div className="flex items-center">
            <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
            <span className="text-xs text-white truncate drop-shadow-md">生成中...</span>
          </div>
        </div>
      ) : segments.length <= 1 ? (
        // 单段：保持现有渲染逻辑不变（需求 6.3）
        <div className="p-1 h-full flex items-center relative z-10">
          <span className="text-xs text-white truncate drop-shadow-md">{clip.name}</span>
        </div>
      ) : (
        // 多段：按比例渲染分段区域（需求 6.1、6.2、6.4）
        <div className="h-full flex items-stretch relative z-10">
          {segments.map((seg, i) => {
            const segWidth = (seg.endOffset - seg.startOffset) / clip.duration * 100;
            const isLast = i === segments.length - 1;
            return (
              <div
                key={i}
                className={`flex items-center px-1 overflow-hidden${isLast ? '' : ' border-r border-white/30'}`}
                style={{ width: `${segWidth}%` }}
              >
                <span className="text-xs text-white truncate drop-shadow-md">{seg.text}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
